import { CONTACT_EMAIL } from "@/lib/assets";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="heading text-2xl text-[#67e8f9] mb-3">{title}</h2>
    <div className="font-rajdhani text-gray-300 text-base leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-16" data-testid="privacy-policy-page">
      <p className="font-rajdhani uppercase tracking-widest text-xs text-gray-500 mb-2">Legale</p>
      <h1 className="heading text-4xl sm:text-5xl text-white mb-2">Privacy <span className="text-[#67e8f9]">Policy</span></h1>
      <p className="font-rajdhani text-gray-500 text-sm mb-10">Ultimo aggiornamento: agosto 2026</p>

      <Section title="1. Titolare del trattamento">
        <p>Il titolare del trattamento dei dati è lo staff di <strong>Seals / Seals Allies Force</strong>.
        Per qualsiasi richiesta relativa alla privacy puoi scrivere a <a className="text-[#67e8f9] underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
      </Section>

      <Section title="2. Dati che raccogliamo">
        <p>Nell'ambito della partecipazione ai tornei e all'uso della community possiamo trattare:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Nome utente Discord e identificativo Discord;</li>
          <li>Activision ID e statistiche di gioco (es. K/D) fornite volontariamente;</li>
          <li>Nome squadra, composizione roster e risultati delle partite;</li>
          <li>Eventuali screenshot temporanei caricati come prova del K/D o dei risultati;</li>
          <li>Indirizzo email, solo se ci contatti direttamente.</li>
        </ul>
      </Section>

      <Section title="3. Finalità del trattamento">
        <p>Utilizziamo i dati esclusivamente per: gestire le iscrizioni e le lobby dei tornei,
        calcolare classifiche e statistiche, comunicare con i caposquadra, verificare manualmente
        quando richiesto i valori K/D e i risultati presentati e garantire il corretto
        svolgimento delle competizioni.</p>
      </Section>

      <Section title="4. Base giuridica">
        <p>Il trattamento si basa sul consenso fornito al momento dell'iscrizione tramite il bot Discord
        e sul legittimo interesse a organizzare e gestire i tornei.</p>
      </Section>

      <Section title="5. Conservazione dei dati">
        <p>I dati strutturati necessari a storico, classifiche e statistiche vengono conservati
        secondo le finalità del servizio. Gli screenshot utilizzati come prova del K/D o dei risultati
        sono invece evidenze temporanee e possono essere rimossi quando il torneo viene archiviato.
        Per un K/D verificato possono essere conservati il valore numerico, la modalità, la data di verifica,
        la scadenza e i metadati necessari all'audit, senza conservare permanentemente lo screenshot.</p>
      </Section>

      <Section title="6. Condivisione con terze parti">
        <p>I dati non vengono venduti. Alcune informazioni transitano attraverso <strong>Discord</strong>
        (piattaforma di comunicazione) esclusivamente per la gestione delle iscrizioni,
        delle comunicazioni e delle verifiche necessarie allo svolgimento dei tornei.</p>
      </Section>

      <Section title="7. Diritti dell'utente">
        <p>Hai il diritto di accedere, rettificare o richiedere la cancellazione dei tuoi dati, nonché di
        revocare il consenso in qualsiasi momento scrivendo a <a className="text-[#67e8f9] underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
      </Section>

      <Section title="8. Modifiche">
        <p>Ci riserviamo il diritto di aggiornare la presente informativa. Le modifiche saranno pubblicate su
        questa pagina con la relativa data di aggiornamento.</p>
      </Section>
    </div>
  );
}
